import { useOpenPositionsView } from '#/features/perpetuals/open-positions-context';
import { useTranslation } from '#/features/localization/utils';

import TabLabel, { Badge } from './TabLabel';

export default function TabLabelOpenPositions() {
  const { openPositions } = useOpenPositionsView();
  const { t } = useTranslation();

  return (
    <TabLabel>
      {t('Positions')} <Badge>{openPositions.length}</Badge>
    </TabLabel>
  );
}
